import fetchWithAuth from "../middlewares/fetchWithAuth";
import { API_BASE_URL } from "../config";

const API_URL = `${API_BASE_URL}/equipos`;

// Función para obtener las competiciones
export const getEquiposPorIdTemporadaYLetras = async (
  idTemporada,
  letrasNombre,
  navigate
) => {
  try {
    const response = await fetchWithAuth(
      `${API_URL}/temporadaYLetras/${encodeURIComponent(idTemporada)}/${encodeURIComponent(letrasNombre)}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      navigate
    );

    if (response.ok) {
      const data = await response.json();
      return data;
    }

    throw new Error("Error al obtener las competiciones");
  } catch (error) {
    throw error;
  }
};

export const getJugadoresPorIdEquipo = async (
  idTemporada,
  idEquipo,
  navigate
) => {
  try {
    const response = await fetchWithAuth(
      `${API_URL}/jugadores/${idTemporada}/${idEquipo}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      navigate
    );

    if (response.ok) {
      const data = await response.json();
      return data;
    }

    throw new Error("Error al obtener las competiciones");
  } catch (error) {
    throw error;
  }
};

export const getEquipoByIdTemporadaAndIdEquipo = async (
  idTemporada,
  idEquipo,
  navigate
) => {
  try {
    const response = await fetchWithAuth(
      `${API_URL}/${idTemporada}/${idEquipo}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      navigate
    );

    if (response.ok) {
      const data = await response.json();
      return data.length > 0 ? data[0] : null;
    }

    throw new Error("Error al obtener las competiciones");
  } catch (error) {
    throw error;
  }
};
